'use strict';
const DeviceChecker = {
	init: function() {
		this.detectSafari();
		this.detectIOS();
	},

	detectSafari: function() {
		const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		if (isSafari) {
			document.body.classList.add('safari');
		}
	},

	detectIOS: function() {
		const isIOS = /iP(ad|hone|od)/i.test(navigator.userAgent);
		if (isIOS) {
			document.body.classList.add('ios');
		}
	},
};

export default DeviceChecker;

